import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=06e5c0a7&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=ts"
export * from "./Diagnostic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5c0a7",
  null
  
)

export default component.exports